/* import moment from "moment"; */

const CLEAR_USER = "CLEAR_USER";

const ADD_MAIN_DATA = "ADD_MAIN_DATA";
const ADD_CONTRACTS = "ADD_CONTRACTS";
const UPDATE_CONTRACT_BALANCE = "UPDATE_CONTRACT_BALANCE";
const SET_CONTRACT_BALANCE = "SET_CONTRACT_BALANCE";
const ADD_PH_ADR = "ADD_PH_ADR";
const ADD_BILLS = "ADD_BILLS";
const ADD_BENFICIARIES = "ADD_BENFICIARIES";

const CLEAR_CONTRACTS = "CLEAR_CONTRACTS";
const CLEAR_BENFICIARIES = "CLEAR_BENFICIARIES";
const CLEAR_BILLS = "CLEAR_BILLS";
/* const UPDATE_EXPIRE_SESSION = "UPDATE_EXPIRE_SESSION"; */
const UPDATE_EMAIL_USER = "UPDATE_EMAIL_USER";
const ADD_P_PH = "ADD_P_PH";
const ADD_C_PH = "ADD_C_PH";
const ADD_P_EM = "ADD_P_EM";
const UPD_N_L_A = "UPD_N_L_A";
const ADD_PATIENT = "ADD_PATIENT";
const ADD_GRUPO = "ADD_GRUPO";
const CLEAR_GRUPO = "CLEAR_GRUPO";
const ADD_PREVIOUS_PATIENT = "ADD_PREVIOUS_PATIENT";
const ADD_DATE_NOBPM = "ADD_DATE_NOBPM";
const UPDATE_TERMS_AND_CONDITIONS= "UPDATE_TERMS_AND_CONDITIONS";
const LOAD_GRUPO = "LOAD_GRUPO";
const SET_ERROR_TELEMEDICINA = "SET_ERROR_TELEMEDICINA";
const CLEAR_SELECTED_PATIENT = "CLEAR_SELECTED_PATIENT";
const LOAD_TELEMEDICINA = "LOAD_TELEMEDICINA";
const OPEN_TELEMEDICINA = "OPEN_TELEMEDICINA";
const REINTENTAR_BENEFICIARIOS = "REINTENTAR_BENEFICIARIOS";
const LOADING_TELEMEDICINA = "LOADING_TELEMEDICINA";
const ADD_RECEIPTS = "ADD_RECEIPTS";
const CLEAR_RECEIPTS = "CLEAR_RECEIPTS";

export {
  CLEAR_USER,
  ADD_MAIN_DATA,
  ADD_CONTRACTS,
  UPDATE_CONTRACT_BALANCE,
  ADD_PH_ADR,
  ADD_BILLS,
  ADD_BENFICIARIES,
  CLEAR_CONTRACTS,
  CLEAR_BENFICIARIES,
  CLEAR_BILLS,
  /* UPDATE_EXPIRE_SESSION, */
  SET_CONTRACT_BALANCE,
  UPDATE_EMAIL_USER,
  ADD_P_PH,
  ADD_C_PH,
  ADD_P_EM,
  UPD_N_L_A,
  ADD_PATIENT,
  ADD_GRUPO,
  CLEAR_GRUPO,
  ADD_PREVIOUS_PATIENT,
  ADD_DATE_NOBPM,
  UPDATE_TERMS_AND_CONDITIONS,
  LOAD_GRUPO,
  SET_ERROR_TELEMEDICINA,
  CLEAR_SELECTED_PATIENT,
  LOAD_TELEMEDICINA,
  OPEN_TELEMEDICINA,
  REINTENTAR_BENEFICIARIOS,
  LOADING_TELEMEDICINA,
  ADD_RECEIPTS,
  CLEAR_RECEIPTS
};

function addMainData(data) {
  /* const dateTime = moment(new Date()).add(1770, 's').toDate().getTime(); */
  return {
    type: ADD_MAIN_DATA,
    user: {
      name: data.names,
      lastName: data.lastName,
      docType: data.docType,
      docNumber: data.docNumber,
      email: data.email,
      fechaNacimiento: data.fechaNacimiento,
      genero: data.genero,
      age: data.age,
      /* expireSession: dateTime */
    }
  };
}

function addContracts(data) {
  return {
    type: ADD_CONTRACTS,
    user: {
      contracts: data.contracts
    }
  };
}

function updateContractsBalance(data) {
  return {
    type: UPDATE_CONTRACT_BALANCE,
    contracts: data
  };
}

function addPhoneAddress(data) {
  return {
    type: ADD_PH_ADR,
    user: {
      phone: data.phone,
      address: data.address
    }
  };
}

function updateNameLastNameAge(data) {
  return {
    type: UPD_N_L_A,
    user: {
      name: data.names,
      lastName: data.lastName,
      age: data.age
    }
  };
}

function addPersonalPhone(data) {
  return {
    type: ADD_P_PH,
    user: {
      phone: data.phone,
      contractNumber: data.contractNumber
    }
  };
}

function addCellPhone(data) {
  return {
    type: ADD_C_PH,
    user: {
      phone: data.phone,
      contractNumber: data.contractNumber
    }
  };
}

function addPersonalEmail(data) {
  return {
    type: ADD_P_EM,
    user: {
      email: data.email,
      contractNumber: data.contractNumber
    }
  };
}

function addBeneficiaries(data) {
  return {
    type: ADD_BENFICIARIES,
    user: {
      beneficiaries: data.beneficiaries
    }
  };
}

function addBills(data) {
  return {
    type: ADD_BILLS,
    user: {
      bills: data.bills,
      index: data.index
    }
  };
}

function clearUser() {
  localStorage.removeItem("ECCO_IND_AUTH");
  return {
    type: CLEAR_USER,
    user: {}
  };
}

function clearContracts() {
  return {
    type: CLEAR_CONTRACTS,
    user: {
      contracts: []
    }
  };
}

function clearBeneficiaries() {
  return {
    type: CLEAR_BENFICIARIES,
    user: {
      beneficiaries: []
    }
  };
}

function clearBills(data) {
  return {
    type: CLEAR_BILLS,
    user: {
      index: data
    }
  };
}

/* function updateExpireSession(expireSession) {
  return {
    type: UPDATE_EXPIRE_SESSION,
    user: {
      expireSession: expireSession
    }
  }
} */

function setContractBalance(number,balance) {
  return {
    type: SET_CONTRACT_BALANCE,
    payload: {
      number: number,
      balance: balance
    }
  }
}

function updateEmailUser(email) {
  return {
    type: UPDATE_EMAIL_USER,
    user: {
      email: email
    }
  }
}

function setSelectedPatient(data) {
  return {
    type: ADD_PATIENT,
	  user:{
        selectedPatient: data 
    },
  }
}

function addGrupo(data) {
  return {
    type: ADD_GRUPO,
    user: {
      grupo: data.grupo
    }
  };
}

function clearGrupo() {
  return {
    type: CLEAR_GRUPO,
    user: {
      grupo: []
    }
  };
}

function setPreviousSelectedPatient(data) {
  return {
    type: ADD_PREVIOUS_PATIENT,
	  user:{
      previousSelectedPatient: data 
    },
  }
}

function addDateNoBPM(data) {
  return {
    type: ADD_DATE_NOBPM,
    user: {
      fechaNoBPM: data.fechaNoBPM,
      numeroDocumento: data.numeroDocumento
    }
  };
}

function updateTermsAndConditions(data) {
  return {
    type: UPDATE_TERMS_AND_CONDITIONS,
    user: {
      termsAndConditions: data
    }
  }
}

function setLoadGrupo(data) {
  return {
    type: LOAD_GRUPO,
	  user:{
        loadGrupo: data 
    },
  }
}

function setErrorTelemedicina(data) {
  return {
    type: SET_ERROR_TELEMEDICINA,
	  user:{
        errorTelemedicina: data 
    },
  }
}

function clearSelectedPatient() {
  return {
    type: CLEAR_SELECTED_PATIENT,
    user: {
      selectedPatient: ""
    }
  };
}

function loadTelemedicina(data){
  return {
    type: LOAD_TELEMEDICINA,
    user: {
      loadTelemedicina: data
    }
  };
}

function openTelemedicina(data){
  return {
    type: OPEN_TELEMEDICINA,
    user: {
      openTelemedicina: data
    }
  };
}

function reintentarBeneficiarios(data){
  return {
    type: REINTENTAR_BENEFICIARIOS,
    user: {
      reintentarBeneficiarios: data
    }
  };
}

function loadingTelemedicina(data){
  return {
    type: LOADING_TELEMEDICINA,
    user: {
      loadingTelemedicina: data
    }
  };
}

function addReceipts(data) {
  return {
    type: ADD_RECEIPTS,
    user: {
      receipts: data.receipts,
      index: data.index
    }
  };
}

function clearReceipts(data) {
  return {
    type: CLEAR_RECEIPTS,
    user: {
      index: data
    }
  };
}


export {
  addMainData,
  addContracts,
  updateContractsBalance,
  addPhoneAddress,
  addBeneficiaries,
  addBills,
  clearUser,
  clearContracts,
  clearBills,
  clearBeneficiaries,
/*   updateExpireSession, */
  setContractBalance,
  updateEmailUser,
  addPersonalPhone,
  addCellPhone,
  addPersonalEmail,
  updateNameLastNameAge,
  setSelectedPatient,
  addGrupo,
  clearGrupo,
  setPreviousSelectedPatient,
  addDateNoBPM,
  updateTermsAndConditions,
  setLoadGrupo,
  setErrorTelemedicina,
  clearSelectedPatient,
  loadTelemedicina,
  openTelemedicina,
  reintentarBeneficiarios,
  loadingTelemedicina,
  addReceipts,
  clearReceipts
};
